import { render, staticRenderFns } from "./DashboardPie.vue?vue&type=template&id=521bab9a&"
import script from "./DashboardPie.vue?vue&type=script&lang=js&"
export * from "./DashboardPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports